import { DatePicker as AntDatePicker } from "antd";
import { DatePickerProps } from "antd/lib/date-picker";
import React from "react";

export declare type IDatePickerProps = DatePickerProps;

export const DatePicker: React.FC<IDatePickerProps> = (props) => {
  return <AntDatePicker {...props} />;
};
